import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import "./Header.scss";

import { Link } from "react-router-dom";
import AuthorityCheckRoute from "utils/AuthorityCheckRoute";
import { UserAuthorityChoice } from "utils/common";
import { SERVER_HOST } from "Constants";
import { getUser } from "apis/LoginApi";
import RmtechLogo from "assets/rmtech_logo.png";

const joinUrl = (host, path) => {
  if (!path) {
    return "";
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const baseHost = host || "";
  const normalizedHost = baseHost.endsWith("/") ? baseHost : `${baseHost}/`;
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;

  return `${normalizedHost}${normalizedPath}`;
};

export default function Header() {
  const [logoImage, setLogoImage] = useState(RmtechLogo);

  useEffect(() => {
    let isMounted = true;

    const loadUserLogo = async () => {
      const result = await getUser();

      if (!isMounted || result?.status !== true) {
        return;
      }

      const ciLogo =
        result.data?.ciLogo || result.data?.ci_logo || result.data?.["ci-logo"];

      setLogoImage(ciLogo ? joinUrl(SERVER_HOST, ciLogo) : RmtechLogo);
    };

    loadUserLogo().catch(() => {
      if (isMounted) {
        setLogoImage(RmtechLogo);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Navbar
        bg="primary"
        variant="dark"
        style={{ marginLeft: "0", maxHeight: "80px" }}
      >
        <Container
          style={{ marginLeft: "0", marginRight: "0", maxWidth: "100%" }}
        >
          <Navbar.Brand>
            <AuthorityCheckRoute
              authority={[
                UserAuthorityChoice.ADMIN,
                UserAuthorityChoice.REMS_AND_API,
                UserAuthorityChoice.REMS,
                UserAuthorityChoice.API,
              ]}
            >
              <div className="title">
                <Link
                  to="/"
                  style={{
                    color: "inherit",
                    textDecoration: "inherit",
                    marginLeft: 20,
                  }}
                >
                  RTU Manager
                </Link>
              </div>
            </AuthorityCheckRoute>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse
            className="justify-content-end"
            style={{ marginRight: "20px" }}
          >
            <Navbar.Text>
              <img
                className="header-logo"
                src={logoImage}
                alt="Logo"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = RmtechLogo;
                }}
              />
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
